<template>
  <div class="">
    <input class="form-control my-2" placeholder="جست و جو با حروف انگلیسی" type="text" v-model="iconName">

    <div class="text-center icon-box-section">
      <b-container>

        <b-row>
          <div class="col-lg-2 text-center" v-for="(icon,key) in searchStringInArray()">

            <div @click="selectIcon(icon)">
              <b-icon class="p-2 col-lg-12 m-1 h1"
                      :key="key" :icon="icon"/>
            </div>
          </div>
        </b-row>
      </b-container>

    </div>
  </div>

</template>

<script>
import * as bIcons from 'bootstrap-vue/src/icons/icons'

export default {
  name: "IconPicker",
  data() {
    return {
      iconName: '',
      icons: [],
      bIcons,
    }
  },
  methods: {
    searchStringInArray() {
      let result = []

      if (this.iconName === '') {
        return this.icons.slice(0, 25)
      }

      for (var j = 0; j < this.icons.length; j++) {
        if (this.icons[j].match(this.iconName)) result.push(this.icons[j])
      }
      return result;
    },
    selectIcon(value) {
      this.$emit('icon', value)
    },
    convertIconName(name) {
      // convert icon name to something supported by b-icon component.
      return name.replace('BIcon', '').split(/\.?(?=[A-Z])/).join('-').toLowerCase()
    },
    setIcons() {
      for (const icon in this.bIcons) {
        const iconName = this.convertIconName(icon);
        if (iconName !== 'blank') {
          this.icons.push(iconName)
        }
      }
    }
  },
  mounted() {
    // set icons
    this.setIcons()
  }

}
</script>

<style scoped>
.icon-box-section {
  height: 150px;
  overflow-y: auto;
  width: 100%;
}
</style>